module.exports = __webpack_public_path__ + "static/parade-2019-house19-b10abb8b7f2f99d86d3b8c77a071ac2f.jpg";